import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { insertPopoverContainer } from '@bingads-webui-campaign/fluctuation-common';
import { GridTooltip } from '@bingads-webui-campaign/grid-tooltip';

export const mccPerfFluxPopupContainerId = 'mcc-perf-fluctuation-placeholder';

export const dismissFlucCallout = () => {
  const calloutElement = document.getElementById(mccPerfFluxPopupContainerId);
  if (calloutElement) {
    ReactDOM.unmountComponentAtNode(calloutElement);
  }
};

export const renderFluctuationInsightsTooltip = ({
  i18n, event, view,
}) => {
  insertPopoverContainer(mccPerfFluxPopupContainerId);
  const tooltipProps = {
    parentView: view,
    popoverId: 'fluctuation-tooltip-id',
    target: event.currentTarget,
    show: true,
    onClose: dismissFlucCallout,
    onMouseLeave: dismissFlucCallout,
    closeButton: false,
    placement: 'top',
    content: (<span className="fluctuation-tooltip">{i18n.getString('Fluctuation_Insights_Icon_Tooltip')}</span>),
  };

  ReactDOM.render(
    <GridTooltip {...tooltipProps} />,
    document.getElementById(mccPerfFluxPopupContainerId)
  );
};

export const hideFluctuationInsightsTooltip = ({ event, view }) => {
  if ($(event.relatedTarget).closest('#fluctuation-tooltip-id').length === 0) {
    view.trigger('closePopup');
  }
};
